export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            <div className="sm:col-span-2 lg:col-span-1">
              <a href="#hero" className="flex items-center gap-2 mb-4 cursor-pointer">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-movie-2-line"></i>
                </span>
                <span className="text-lg font-heading text-foreground-100">大师兄影视</span>
              </a>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                大师兄影视汇聚电视剧全集、电影大全、热门综艺与经典影片，高清免费在线观看，不缓冲秒开播放，极速加载流畅观影，海量片库一网打尽。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4 font-heading">
                <a href="#hero" className="hover:text-primary-400 transition-colors cursor-pointer">快速导航</a>
              </h4>
              <ul className="space-y-2.5">
                <li><a href="#ranking" onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">热播风云榜</a></li>
                <li><a href="#updates" onClick={(e) => { e.preventDefault(); document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">最新动态</a></li>
                <li><a href="#cards" onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">精选推荐</a></li>
                <li><a href="#faq" onClick={(e) => { e.preventDefault(); document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a></li>
                <li><a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4 font-heading">
                <a href="#features" className="hover:text-primary-400 transition-colors cursor-pointer">平台优势</a>
              </h4>
              <ul className="space-y-2.5">
                <li className="text-sm text-foreground-500">海量高清片库</li>
                <li className="text-sm text-foreground-500">不缓冲秒开播放</li>
                <li className="text-sm text-foreground-500">极速加载流畅观影</li>
                <li className="text-sm text-foreground-500">每日持续更新</li>
                <li className="text-sm text-foreground-500">多设备无缝切换</li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4 font-heading">合作伙伴</h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                大师兄影视与多家内容平台保持良好合作关系，持续为用户提供丰富的影视资源。
              </p>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-200/40 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-600">
              &copy; {new Date().getFullYear()} 大师兄影视. All rights reserved.
            </p>
            <p className="text-xs text-foreground-700">
              本站内容仅供学习交流，请支持正版
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}